export const sanitizeSearchTerm = (searchTerm: string | string[] | undefined) =>
    String(searchTerm)
        .trim()
        .replace(/\t|\n|%|&|#|\+/g, "");
